<ng-container *ngIf="summary$ | async as summary">
    <span class="linear-container-possible-winnings__label">{{ messages.linear.ToReturn }}</span>
    <span class="linear-container-possible-winnings__value--original" *ngIf="summary.originalWinnings">
        {{ summary.originalWinnings | bsCurrency: true }}</span
    >
    <span class="linear-container-possible-winnings__value"> {{ getPossibleWinningsValue(summary) | bsCurrency: true }}</span>
</ng-container>
